import React from 'react';
import HeroSection from '../HeroSection';

function HomeHero() {
  return (
    <HeroSection 
      title="Elektricien nodig? Direct bereikbaar"
      description="Een elektricien nodig? Onze elektriciens zijn direct bereikbaar voor alle elektrische werkzaamheden."
      imageSrc="/images/mark.png"
    />
  );
}

export default HomeHero;